import type { SystemStyleFunction } from "@chakra-ui/theme-tools";
import { IOS_NO_ZOOM_FONT_SIZE } from "../input/Input.styles";

const baseStyle: SystemStyleFunction = () => {
    return {
        borderStyle: "solid",
        borderWidth: "1px",
        fontWeight: "bold",
        // A resizable multi-line box is a poor fit for the scale-down trick the Input
        // sizes use, so this stays at the no-zoom size on every breakpoint.
        fontSize: IOS_NO_ZOOM_FONT_SIZE,
        color: "black",
        borderRadius: "full",
        borderColor: "gray.400",
        bg: "white",
        _selected: {
            outline: "none",
        },
        _invalid: {
            bg: "red.50",
            boxShadow: "none",
        },
        _focus: {
            bg: "white",
            zIndex: 1,
            transitionProperty: "none",
            transitionDuration: "0s",
            outlineWidth: ".5px",
            outlineStyle: "solid",
            outlineColor: "black",
            outlineOffset: "0",
            boxShadow: "none",
        },
    };
};

export const textAreaStyles = {
    baseStyle,
};
